import createIcon from '../../createIcon';

/**
 * @component @name TabletAndroid
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMEg2QzQuMzQgMCAzIDEuMzQgMyAzVjIxQzMgMjIuNjYgNC4zNCAyNCA2IDI0SDE4QzE5LjY2IDI0IDIxIDIyLjY2IDIxIDIxVjNDMjEgMS4zNCAxOS42NiAwIDE4IDBaTTE0IDIySDEwVjIxSDE0VjIyWk0xOS4yNSAxOUg0Ljc1VjNIMTkuMjVWMTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TabletAndroid = createIcon('TabletAndroid', [
  [
    'path',
    {
      d: 'M18 0H6C4.34 0 3 1.34 3 3V21C3 22.66 4.34 24 6 24H18C19.66 24 21 22.66 21 21V3C21 1.34 19.66 0 18 0ZM14 22H10V21H14V22ZM19.25 19H4.75V3H19.25V19Z',
      key: 'nfr6ed',
    },
  ],
]);

export default TabletAndroid;
